import { View } from 'react-native';
import { ImageInterop } from '@/common/components/ImageInterop/ImageInterop';
import { ImageProps } from 'expo-image';
import { TIllustrationProps } from './types';

export type TIllustrationImageProps = TIllustrationProps & {
  source: ImageProps['source'];
  blurhash?: string;
  thumbhash?: string;
  transition?: number;
};

export function IllustrationImage({
  width,
  height,
  source,
  blurhash,
  thumbhash,
  transition,
}: TIllustrationImageProps) {
  const placeholder = {
    blurhash,
    thumbhash,
  };
  return (
    <View style={{ width, height }}>
      <ImageInterop
        source={source}
        contentFit="contain"
        placeholder={placeholder}
        transition={transition}
        className="h-full w-full"
      />
    </View>
  );
}
